const currency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

export const formatMoney = (
  value: string | number | null | undefined
): string => {
  if (value === '' || value == null) {
    return '';
  }
  const amount = Number(value);
  return Number.isFinite(amount) ? currency.format(amount) : '';
};
